import { configureStore } from '@reduxjs/toolkit';
import webSettingsReducer from './webSettings';
import topSellingProductsReducer from './topSellingProducts';
import productsReducer from './products';
import categoriesReducer from './categories';
import subProductsReducer from './subProducts';
import viewImagesReducer from './viewImages';
import cartItemsReducer from './cartItems';
import productsWithGroupsReducer from './productsWithGroups';
import todaysDealsReducer from './todaysDeals';
import recentlyViewedReducer from './recentlyViewed';
import alertReducer from './alert';
import favoritesReducer from './favorites';
import aboutReducer from './about';
import userReducer from './user';
import recentlySearchedReducer from './recentlySearched';
import homeCategoriesReducer from './homcategoriesSlice';
import locationReducer from './location';

export default configureStore({
	reducer: {
		webSettings: webSettingsReducer,
		topSellingProducts: topSellingProductsReducer,
		products: productsReducer,
		categories: categoriesReducer,
		subProducts: subProductsReducer,
		viewImages: viewImagesReducer,
		cartItems: cartItemsReducer,
		productsWithGroups: productsWithGroupsReducer,
		todaysDeals: todaysDealsReducer,
		recentlyViewed: recentlyViewedReducer,
		recentlySearched: recentlySearchedReducer,
		alert: alertReducer,
		favorites: favoritesReducer,
		homeCategories: homeCategoriesReducer,
		about: aboutReducer,
		user: userReducer,
		location: locationReducer,
	},
});
